import React from 'react';
import { withProps, compose, pure } from 'recompose';
import { path, prop } from 'ramda';
import { Game as CommonGame, GAME_LAUNCH_TYPE } from 'js/components/main/CasinoGame';
import { PlayButton, DemoButton } from 'js/components/main/CasinoGame/Buttons';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';
import { getLocationParam } from 'js/utils/url.util';
import { StatusBadge } from '../../common/StartStatusBadge';
import { RACE_RULE_STATUSES } from '../../constants';
import style from './index.scss';

export const GameStatusBadge = withProps(
    ({ status: ruleStatus }) => {
        const tkPrefix = 'playtech.mobile.mystery-parcel-page.';

        return {
            status: ruleStatus === RACE_RULE_STATUSES.approved ? 'notStarted' : ruleStatus.toLowerCase(),
            tKeyPrefix: `${tkPrefix}gameItem.status.`
        };
    }
)(StatusBadge);

export const HoveredGame = ({ code, name, showDemoButton, hideButtons, gameLaunchType, isShowGameName,
                                isShowPlayButtonOnHover, gameIndexInArray, trackChangeGameClick }) => (
    <div className={style.hovered}>
        {isShowGameName ? <div className={style.title}>{name}</div> : <></>}
        {!hideButtons &&
        <div className={style.buttons}>
            {showDemoButton && <DemoButton code={code} name={name} isHoverBtn={true} gameLaunchType={gameLaunchType} />}
            <PlayButton code={code} name={name} isHoverBtn={true} gameLaunchType={gameLaunchType}
                        isShowPlayButtonOnHover={isShowPlayButtonOnHover} gameIndexInArray={gameIndexInArray}
                        trackChangeGameClick={trackChangeGameClick}/>
        </div>
        }
    </div>
);

export const Game = ({ status, code, className, isDesktop, setGameRef, hideButtons, gameLaunchType, imageClassName,
                         isShowGameName, isShowPlayButtonOnHover, imageComponentOnHover, trackChangeGameClick,
                         gameIndexInArray, ...rest }) => (
    <div className={`${style.game} ${className}`} ref={setGameRef}>
        <CommonGame {...{
            code,
            hideButtons,
            gameLaunchType,
            showTitle: false,
            imageClassName,
            isRelativeSize: true,
            showRecentlyPlayedIcon: false,
            showFavoriteIcon: false,
            showFeatureIcons: false,
            showGameInfo: false,
            disableGameLaunch: hideButtons,
            size: 'medium',
            isInH2SPages: true
        }} />
        {status && <GameStatusBadge className={style.badge} status={status}/>}
        {isDesktop && !hideButtons && <HoveredGame code={code} isShowGameName={isShowGameName}
                                                   gameLaunchType={gameLaunchType} hideButtons={hideButtons}
                                                   isShowPlayButtonOnHover={isShowPlayButtonOnHover}
                                                   gameIndexInArray={gameIndexInArray}
                                                   trackChangeGameClick={trackChangeGameClick}
                                                   {...rest} />}
    </div>
);

export default compose(
    pure,
    withProps(
        ({ code, className, imageClassName, isShowGameName, isShowPlayButtonOnHover, trackChangeGameClick,
             gameIndexInArray }) => {
            const isDesktop = useDeviceSelector(prop('isDesktop'));
            const { name, funSupport } = useAppSelector(path(['games', code]));
            const enableDemoMode = useAppSelector(path(['leaderboard', 'enableDemoMode']));
            const hideButtons = getLocationParam('showGameSwitch') === '0';
            const gameLaunchType = getLocationParam('showGameSwitch') === '1' ? GAME_LAUNCH_TYPE.Casino : GAME_LAUNCH_TYPE.Default;

            return {
                name,
                className,
                imageClassName,
                isDesktop,
                hideButtons,
                gameLaunchType,
                isShowGameName,
                gameIndexInArray,
                isShowPlayButtonOnHover,
                showDemoButton: !(funSupport === 'unavailable' || funSupport === 'guest') && enableDemoMode,
                trackChangeGameClick
            };
        }
    )
)(Game);
